var installedModules = {};
var moduleToHandlerMapping = {
	9567: {
		getter: () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(31398))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk",
	},
	14636: {
		getter: () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(80436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	19929: {
		getter: () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(47172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	28079: {
		getter: () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(60316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	33282: {
		getter: () => (__webpack_require__.e(920).then(() => (() => (__webpack_require__(60920))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	35717: {
		getter: () => (__webpack_require__.e(7404).then(() => (() => (__webpack_require__(7404))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	42862: {
		getter: () => (__webpack_require__.e(5485).then(() => (() => (__webpack_require__(25485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	47971: {
		getter: () => (__webpack_require__.e(1543).then(() => (() => (__webpack_require__(3924))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	76207: {
		getter: () => (__webpack_require__.e(3382).then(() => (() => (__webpack_require__(11001))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	79649: {
		getter: () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(46443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	85895: {
		getter: () => (__webpack_require__.e(7254).then(() => (() => (__webpack_require__(74873))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.64.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	91492: {
		getter: () => (__webpack_require__.e(9334).then(() => (() => (__webpack_require__(86953))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	92137: {
		getter: () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(34456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	93516: {
		getter: () => (__webpack_require__.e(781).then(() => (() => (__webpack_require__(33162))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx-react-lite",
	},
	79519: {
		getter: () => (__webpack_require__.e(9745).then(() => (() => (__webpack_require__(9745))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	86201: {
		getter: () => (__webpack_require__.e(5420).then(() => (() => (__webpack_require__(13039))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.64.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		35717
	],
	"436": [
		28079,
		35717,
		79649
	],
	"781": [
		79519
	],
	"1001": [
		33282,
		79519,
		85895
	],
	"3039": [
		33282
	],
	"3162": [
		33282,
		42862,
		79519
	],
	"3382": [
		79519
	],
	"3924": [
		14636,
		28079,
		35717
	],
	"4456": [
		28079,
		35717
	],
	"4873": [
		33282,
		86201
	],
	"6443": [
		28079,
		35717
	],
	"6668": [
		9567,
		14636,
		19929,
		28079,
		33282,
		35717,
		42862,
		47971,
		76207,
		79649,
		85895,
		91492,
		92137,
		93516
	],
	"6953": [
		33282,
		42862
	],
	"7172": [
		28079,
		35717
	],
	"7254": [
		86201
	],
	"7474": [
		86201
	],
	"7866": [
		33282
	],
	"8055": [
		79649
	],
	"9017": [
		35717
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}